<template>
  <div>
    <label>{{$t("views.agreements.form.advancePayment")}}:</label>
    <b-form-group>
      <b-form-radio-group buttons button-variant="outline-primary" id="advance_payment" v-model="data.advanceStatus" aria-controls="advance_payment_collapse">
        <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
        <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <b-collapse id="advance_payment_collapse" v-model="visible">
      <b-row>
        <div class="form-group col-md-4 col-sm-12">
            <label for="advanceValue">{{$t("views.agreements.form.advanceValue")}}:</label>
            <input v-model="data.advanceValue" name="advanceValue" :placeholder="$t('views.agreements.form.advanceValue')" class="form-control" id="advanceValue"/>
        </div>
        <div class="form-group col-md-8 col-sm-12">
          <label>{{$t("views.agreements.form.advanceDate")}}</label>
          <VueCtkDateTimePicker no-header
                                :label="$t('views.agreements.form.advanceDate')"
                                v-model="data.advanceDate"
                                format="YYYY-MM-DD"
                                :noButtonNow="true"
                                :onlyDate="true"
                                :right="true"
                                formatted="ll"
                                :no-label="true"
          >
          </VueCtkDateTimePicker>
        </div>
        <div class="form-group col-md-12 col-sm-12">
          <label for="advanceDescription">{{$t("views.agreements.form.advanceDescription")}}:</label>
          <input v-model="data.advanceDescription" name="advanceDescription" type="text" autofocus :placeholder="$t('views.agreements.form.advanceDescription')" class="form-control" id="advanceDescription"/>
        </div>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'AdvancePayment',

  components: {
    VueCtkDateTimePicker
  },

  props: ['data', 'violations'],

  computed: {
    visible: {
      get () {
        return Boolean(this.data.advanceStatus)
      },
      set (val) {
        // +true === 1
        // +false === 0
        this.data.advanceStatus = +val
      }
    }
  }
}
</script>

<style scoped>

</style>
